const getParams = (filters, resetCoordinates = false, rectBounds, center) => {
    let params = {};
    for (var propName in filters.value) {
        if (propName == "facets") {
            for (var param in filters.value.facets) {
                var val = filters.value.facets[param];
                if (_.isArray(val)) {
                    if (val.length > 0) {
                        params[param] = val;
                    }
                } else {
                    if (val !== "") {
                        params[param] = val;
                    }
                }
            }
        } else {
            if (filters.value[propName] !== "") {
                params[propName] = filters.value[propName];
            }
        }
    }
    if (resetCoordinates) {
        if (filters.value.east) {
            delete filters.value.east;
        }
        if (filters.value.west) {
            delete filters.value.west;
        }
        if (filters.value.north) {
            delete filters.value.north;
        }
        if (filters.value.south) {
            delete filters.value.south;
        }
        if (filters.value.lat) {
            delete filters.value.lat;
        }
        if (filters.value.lng) {
            delete filters.value.lng;
        }
    } else {
        if (rectBounds && center) {
            params.east = rectBounds.east;
            params.west = rectBounds.west;
            params.north = rectBounds.north;
            params.south = rectBounds.south;
            params.lat = center.lat;
            params.lng = center.lng;
        }
    }
    params.size = 12;

    return params;
}

export default getParams;